import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import '@fontsource/fraunces/500.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/fraunces/500-italic.css';
import '@fontsource-variable/instrument-sans';
// The Helios type (Moderno and Futurístico): only downloaded when a look asks for it.
import '@fontsource-variable/manrope';
import '@fontsource/dm-serif-display/400.css';
import './global.css';
import './styles/pos.css';
import './styles/membership.css';
import './styles/chart.css';
import './styles/customer-file.css';
import './styles/reports.css';
import './styles/factura.css';
import './styles/permissions.css';
import './styles/look-helios.css';
import './styles/look-helios-extra.css';
import './styles/look-paleta-helios.css';
import './styles/shell-helios.css';
import './styles/agents-team.css';
import './styles/tema-noche.css';
import './styles/account.css';
import './styles/agents.css';
import './styles/intelligence.css';
// Dale HQ, the owner's panel: its own frame and places, over the tokens of Dale.
import './styles/hq.css';
// Futurístico's glass goes last: it only re-reads the tokens the layers above already use.
import './styles/look-vidrio.css';
import './styles/plan-locked.css';
import './styles/motion.css';
import { applyLook, listenForLookRequests } from './lib/lookStore';
import { applyTema } from './lib/tema';
import { queryClient } from './lib/queryClient';
import { router } from './router';

// The chosen look lands on <html> before the first paint, so nothing flashes.
applyLook();
applyTema();
// The sales demo's floating switcher asks for a look by name.
listenForLookRequests();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No se encontró el elemento #root.');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
